const fonts = {
  heading: 'Roboto',
  body: 'Roboto',
};

export default fonts;
